import moment from "moment";

export const convertToYears = (date: Date) => {
  return moment(date).format("YYYY-MM-DD");
};
